import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import TransparentButton from '@/trio-ui/TransparentButton';
import * as Styles from './PreviewDocRow.styles';

export type PreviewDocRowProps = {
  title: string;
  buttonLabel?: string;
  onAdd: () => void;
  onEdit: () => void;
  onRemove: () => void;
};

export default function PreviewDocRow({
  title,
  buttonLabel = 'Add',
  onAdd,
  onEdit,
  onRemove,
}: PreviewDocRowProps): JSX.Element {
  if (!title) {
    return (
      <Styles.CustomButton onClick={onAdd} variantStyle="outline">
        {buttonLabel}
      </Styles.CustomButton>
    );
  }

  return (
    <Styles.Row>
      <Styles.Title title={title}>{title}</Styles.Title>

      <div className="flex">
        <TransparentButton onClick={onEdit} icon={EditIcon}>
          Edit
        </TransparentButton>

        <TransparentButton
          onClick={(event) => {
            event.stopPropagation();
            onRemove();
          }}
          isRedButton
          icon={DeleteIcon}
        >
          Delete
        </TransparentButton>
      </div>
    </Styles.Row>
  );
}
